import xms from '@/utils/xms'

export function getToken() {
  return xms.storageGet('token')
}

export function setToken(token) {
  return xms.storageSet({ token })
}

export function removeToken() {
  return xms.storageRemove('token')
}

export function getLock() {
  return xms.storageGet('lock')
}

export function setLock(lock) {
  return xms.storageSet({ lock })
}

export function removeLock() {
  return xms.storageRemove('lock')
}

export function setLanguage(language) {
	return xms.storageSet({ language })
}

export function getLanguage() {
	return xms.storageGet('language')
}

export function getUser() {
	return xms.storageGet('user')
}

export function setUser(user) {
	return xms.storageSet({ user })
}

export function getConfig() {
	return xms.storageGet('config')
}

export function setConfig(config) {
	return xms.storageSet({ config })
}

export function getResetPwd() {
	return xms.storageGet('isResetPwd')
}

export function setResetPwd(isResetPwd) {
	return xms.storageSet({ isResetPwd })
}

export function getResetToken() {
	return xms.storageGet('resetToken')
}

export function setResetToken(resetToken) {
	return xms.storageSet({ resetToken })
}